import { TextField } from '@cash-me/react-components'
import { getIn, useFormik } from 'formik'

import { applyMask } from 'utils/masks/applyMask'

import { LegalRepresentativeFieldType, SubdelegatedRegistrationFormValues } from './form.model'

type LegalRepresentativeInputFactoryProps = {
  inputProps: LegalRepresentativeFieldType
  namePrefix: 'representanteLegal1' | 'representanteLegal2'
  representativeLabel: string
  formikContext: Pick<
    ReturnType<typeof useFormik<SubdelegatedRegistrationFormValues>>,
    'values' | 'handleBlur' | 'handleChange' | 'setFieldTouched' | 'setFieldValue' | 'errors' | 'touched'
  >
}

export function legalRepresentativeInputFactory({
  inputProps,
  namePrefix,
  representativeLabel,
  formikContext
}: LegalRepresentativeInputFactoryProps) {
  const { id, label, mask, maxLength } = inputProps
  const { values, errors, touched, handleBlur, handleChange, setFieldTouched, setFieldValue } = formikContext
  const name = `${namePrefix}.${id}`
  const error = getIn(errors, name)
  const isTouched = getIn(touched, name)

  return (
    <div key={name}>
      <TextField
        id={name}
        name={name}
        label={label}
        aria-label={`${label} do ${representativeLabel}`}
        value={getIn(values, name)}
        variant="outline"
        noMargin
        maxLength={maxLength}
        onChange={event => {
          setFieldTouched(name, true)
          if (mask) {
            setFieldValue(name, applyMask(event.target.value, mask))
            return
          }
          handleChange(event)
        }}
        onBlur={handleBlur}
        {...(mask && { mask })}
        validation={{
          ...(error && isTouched && { invalid: error }),
          ...(!error && isTouched && { valid: '' })
        }}
        required
      />
    </div>
  )
}
